import { Box, Button, ButtonProps, Dialog, DialogActions, DialogTitle, IconButton, styled } from "@mui/material";
import { hexToRgba } from "@Shared/utilities/hexToRgba";

export const DialogSelectButton = styled((props: ButtonProps) => <Button disableRipple {...props} variant={props.variant || "outlined"} />)(
  ({ theme }) => ({
    borderRadius: theme.spacing(1.5),
    textTransform: "none",
    borderColor: theme.palette.dsSurface.v100,
    backgroundColor: theme.palette.dsSurface.v100,
    color: theme.palette.dsBase.v200,
    padding: theme.spacing(2),
    ...theme.typography.textLg500,
    "&.MuiButton-contained": {
      boxShadow: `0 0 0 1.5px ${theme.palette.dsPrimary.v300}`,
      backgroundColor: theme.palette[theme.palette.mode === "light" ? "dsPrimary" : "dsSurface"].v100,
      color: theme.palette.dsPrimary.v300,
      border: "1px solid",
      ...theme.typography.textLg600,
      ":hover": {
        boxShadow: `0 0 0 3px ${theme.palette.dsPrimary.v300}!important`,
      },
    },
    "&.Mui-focusVisible": {
      boxShadow: `0 0 0 3px ${theme.palette.dsPrimary.v300}!important`,
    },
    ":hover": {
      backgroundColor: theme.palette[theme.palette.mode === "light" ? "dsPrimary" : "dsSurface"].v100,
    },
  })
);

export const StyledDialog = styled(Dialog)<{ transparent?: boolean; width?: string }>(({ theme, transparent, width }) => ({
  "& .MuiDialog-paper": {
    backgroundColor: transparent ? hexToRgba(theme.palette.dsSurface.v100, theme.palette.dsOpacity.high) : `${theme.palette.dsSurface.v100}90`,
    width: width || "auto",
  },
}));

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  boxSizing: "border-box",
  borderColor: theme.palette.dsSurface.v300,
  padding: theme.spacing(4),
}));

export const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
  borderColor: theme.palette.dsSurface.v200,
  justifyContent: "space-between",
  padding: theme.spacing(2, 4, 4),
}));

export const DialogContentDivider = styled(Box)(({ theme }) => ({
  borderBottom: "1px solid grey",
  borderColor: theme.palette.dsSurface.v300,
}));

export const DialogSectionDark = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.dsSurface.v100,
  borderRadius: theme.spacing(3),
  border: "1px solid rgba(238, 238, 238, 0.08);",
  padding: theme.spacing(1, 2),
}));

export const DialogSection = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  width: "100%",
  boxSizing: "border-box",
}));

export const StyledDialogButton = styled(IconButton)(({ theme }) => ({
  position: "fixed",
  backdropFilter: `blur(${theme.spacing(1)})`,
  backgroundColor: `${theme.palette.dsBase.v100}CC`,
  border: `0.5px solid ${theme.palette.dsBase.v200}10`,
  borderRadius: 50,
  color: theme.palette.dsBase.v200,
  width: 50,
  height: 50,
  boxShadow: `0 4px 12px rgba(0, 0, 0, 0.2)`,
  zIndex: 1500,
  pointerEvents: "auto",
  "&:hover": {
    backgroundColor: `${theme.palette.dsBase.v100}E6`,
    borderColor: theme.palette.dsNeutral.v500,
    transform: "scale(1.05)",
  },
  "&:disabled": {
    opacity: 0.3,
  },
}));
